<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-8">
            <h5 class="card-title">Vertragsvorlagen verwalten</h5>
          </div>
          <div class="col-sm-4 text-right">
            <p-button type="primary" @click="openNewTemplate">Neue Vorlage</p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table :data="templates" header-row-class-name="text-primary" empty-text="Es wurden keine Vorlagen gefunden.">
            <el-table-column prop="title" label="Titel" min-width="220">
            </el-table-column>
            <el-table-column label="Standort" min-width="160">
              <template slot-scope="scope">
                {{ locationLabel(scope.row.location) }}
              </template>
            </el-table-column>
            <el-table-column label="Name (x / y)" min-width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.coordinatesName && scope.row.coordinatesName.length >= 2 ? scope.row.coordinatesName[0] : '-' }} /
                  {{ scope.row.coordinatesName && scope.row.coordinatesName.length >= 2 ? scope.row.coordinatesName[1] : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Datum (x / y)" min-width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.coordinatesDate && scope.row.coordinatesDate.length >= 2 ? scope.row.coordinatesDate[0] : '-' }} /
                  {{ scope.row.coordinatesDate && scope.row.coordinatesDate.length >= 2 ? scope.row.coordinatesDate[1] : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Unterschrift (x / y)" min-width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.coordinatesSignature && scope.row.coordinatesSignature.length >= 2 ? scope.row.coordinatesSignature[0] : '-' }} /
                  {{ scope.row.coordinatesSignature && scope.row.coordinatesSignature.length >= 2 ? scope.row.coordinatesSignature[1] : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column class-name="action-buttons td-actions" align="right" label="">
              <template slot-scope="props">
                <el-tooltip content="Vorlage bearbeiten" placement="top">
                  <p-button type="success" size="sm" icon @click="openEditTemplate(props.row)">
                    <i class="fa fa-edit"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="Vorlage löschen" placement="top">
                  <p-button type="danger" size="sm" icon @click="removeTemplate(props.row)">
                    <i class="fa fa-trash"></i>
                  </p-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.edit" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">{{ isEditing ? 'Vorlage bearbeiten' : 'Neue Vorlage' }}</h5>
      <fg-input label="Titel" v-model="form.title" placeholder="Bezeichnung der Vorlage"></fg-input>

      <label class="control-label mt-3">Standort</label>
      <el-select v-model="form.location" placeholder="Standort wählen" style="width: 100%;">
        <el-option
          v-for="loc in locationOptions"
          :key="loc.value"
          :label="loc.label"
          :value="loc.value">
        </el-option>
      </el-select>

      <div class="mt-4">
        <label class="control-label">Name (x / y)</label>
        <div class="d-flex align-items-center mb-2">
          <el-input-number v-model="form.coordinatesNameX" :min="0" :max="1000" size="small"></el-input-number>
          <span class="mx-2">/</span>
          <el-input-number v-model="form.coordinatesNameY" :min="0" :max="1000" size="small"></el-input-number>
        </div>

        <label class="control-label">Datum (x / y)</label>
        <div class="d-flex align-items-center mb-2">
          <el-input-number v-model="form.coordinatesDateX" :min="0" :max="1000" size="small"></el-input-number>
          <span class="mx-2">/</span>
          <el-input-number v-model="form.coordinatesDateY" :min="0" :max="1000" size="small"></el-input-number>
        </div>

        <label class="control-label">Unterschrift (x / y)</label>
        <div class="d-flex align-items-center">
          <el-input-number v-model="form.coordinatesSignatureX" :min="0" :max="1000" size="small"></el-input-number>
          <span class="mx-2">/</span>
          <el-input-number v-model="form.coordinatesSignatureY" :min="0" :max="1000" size="small"></el-input-number>
        </div>
      </div>

      <div class="mt-4">
        <label class="control-label">PDF-Vorlage</label>
        <div class="form-group">
          <input type="file" accept="application/pdf" @change="onPdfSelected" ref="pdfInput" style="display: none;" />
          <p-button type="default" @click="choosePdf">
            <i class="bi bi-file-earmark-pdf"></i>
            {{ pdfFile ? pdfFile.name : (currentPdfName || 'PDF auswählen...') }}
          </p-button>
        </div>
        <div v-if="uploadProgress > 0 && uploadProgress < 100" class="mt-2">
          <div class="progress">
            <div class="progress-bar bg-success" role="progressbar" :style="{ width: uploadProgress + '%' }">{{ uploadProgress }}%</div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="closeModal">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link :disabled="saving" @click="saveTemplate">Speichern</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { db, FirebaseStorage } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, InputNumber, MessageBox, Select, Option } from "element-ui";
import { Modal } from "src/components/UIComponents";
import store from "../../../../store";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);

export default {
  components: {
    [InputNumber.name]: InputNumber,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal,
  },

  data() {
    return {
      templates: [],
      location: store.getters.userlocation,
      role: store.getters.userrole,
      locationOptions: [
        { value: "DA", label: "Darmstadt" },
        { value: "NB", label: "Neroberg" },
        { value: "FRA", label: "Frankfurt" },
      ],
      modals: {
        edit: false,
      },
      isEditing: false,
      currentId: null,
      currentPdfName: "",
      pdfFile: null,
      uploadProgress: 0,
      saving: false,
      form: {
        title: "",
        location: "",
        coordinatesNameX: 0,
        coordinatesNameY: 0,
        coordinatesDateX: 0,
        coordinatesDateY: 0,
        coordinatesSignatureX: 0,
        coordinatesSignatureY: 0,
      },
    };
  },
  created() {
    this.loadTemplates();
  },
  methods: {
    locationLabel(code) {
      const loc = this.locationOptions.find(l => l.value === (code || "").toUpperCase());
      return loc ? loc.label : (code || "-");
    },
    loadTemplates() {
      const ref = db.collection("contractTemplates").orderBy("title");
      ref.onSnapshot((snapshot) => {
        this.templates = [];
        snapshot.forEach((doc) => {
          const d = doc.data();
          this.templates.push({
            id: doc.id,
            title: d.title || "(ohne Titel)",
            location: d.location || "",
            coordinatesName: Array.isArray(d.coordinatesName) ? d.coordinatesName : [],
            coordinatesDate: Array.isArray(d.coordinatesDate) ? d.coordinatesDate : [],
            coordinatesSignature: Array.isArray(d.coordinatesSignature) ? d.coordinatesSignature : [],
            documentTemplateUrl: d.documentTemplateUrl || "",
          });
        });
      });
    },
    resetForm() {
      this.form.title = "";
      this.form.location = "";
      this.form.coordinatesNameX = 0;
      this.form.coordinatesNameY = 0;
      this.form.coordinatesDateX = 0;
      this.form.coordinatesDateY = 0;
      this.form.coordinatesSignatureX = 0;
      this.form.coordinatesSignatureY = 0;
      this.pdfFile = null;
      this.currentPdfName = "";
      this.uploadProgress = 0;
    },
    openNewTemplate() {
      this.isEditing = false;
      this.currentId = null;
      this.resetForm();
      this.modals.edit = true;
    },
    openEditTemplate(row) {
      this.isEditing = true;
      this.currentId = row.id;
      this.form.title = row.title || "";
      this.form.location = row.location || "";
      const nameCoords = row.coordinatesName && row.coordinatesName.length >= 2 ? row.coordinatesName : [0, 0];
      const dateCoords = row.coordinatesDate && row.coordinatesDate.length >= 2 ? row.coordinatesDate : [0, 0];
      const sigCoords = row.coordinatesSignature && row.coordinatesSignature.length >= 2 ? row.coordinatesSignature : [0, 0];
      this.form.coordinatesNameX = nameCoords[0];
      this.form.coordinatesNameY = nameCoords[1];
      this.form.coordinatesDateX = dateCoords[0];
      this.form.coordinatesDateY = dateCoords[1];
      this.form.coordinatesSignatureX = sigCoords[0];
      this.form.coordinatesSignatureY = sigCoords[1];
      this.pdfFile = null;
      this.currentPdfName = row.documentTemplateUrl ? "(bestehende PDF hinterlegt)" : "";
      this.uploadProgress = 0;
      this.modals.edit = true;
    },
    closeModal() {
      this.modals.edit = false;
      this.saving = false;
      this.resetForm();
    },
    choosePdf() {
      if (this.$refs.pdfInput) {
        this.$refs.pdfInput.click();
      }
    },
    onPdfSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (file.type !== "application/pdf") {
        this.pdfFile = null;
        if (this.$refs.pdfInput) this.$refs.pdfInput.value = "";
        MessageBox.alert("Bitte nur PDF-Dateien hochladen.", "Hinweis", { confirmButtonText: "OK" });
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.pdfFile = null;
        if (this.$refs.pdfInput) this.$refs.pdfInput.value = "";
        MessageBox.alert("Die Datei darf maximal 10 MB groß sein.", "Hinweis", { confirmButtonText: "OK" });
        return;
      }
      this.pdfFile = file;
      this.currentPdfName = file.name;
    },
    async uploadPdfIfNeeded() {
      if (!this.pdfFile) {
        return null;
      }
      this.uploadProgress = 0;
      const safeName = this.pdfFile.name.replace(/[\/\\]/g, "_");
      const path = "ContractTemplates/" + Date.now() + "_" + safeName;
      const uploadTask = FirebaseStorage.ref(path).put(this.pdfFile);
      return new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            this.uploadProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          },
          (error) => reject(error),
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((url) => resolve(url))
              .catch((e) => reject(e));
          }
        );
      });
    },
    async saveTemplate() {
      if (!this.form.title || !this.form.location) {
        MessageBox.alert("Bitte Titel und Standort auswählen.", "Hinweis", { confirmButtonText: "OK" });
        return;
      }
      if (!this.isEditing && !this.pdfFile) {
        MessageBox.alert("Bitte eine PDF-Vorlage auswählen.", "Hinweis", { confirmButtonText: "OK" });
        return;
      }
      this.saving = true;
      try {
        let url = null;
        if (this.pdfFile) {
          url = await this.uploadPdfIfNeeded();
        }
        const payload = {
          title: this.form.title,
          location: this.form.location,
          coordinatesName: [
            parseInt(this.form.coordinatesNameX || 0),
            parseInt(this.form.coordinatesNameY || 0),
          ],
          coordinatesDate: [
            parseInt(this.form.coordinatesDateX || 0),
            parseInt(this.form.coordinatesDateY || 0),
          ],
          coordinatesSignature: [
            parseInt(this.form.coordinatesSignatureX || 0),
            parseInt(this.form.coordinatesSignatureY || 0),
          ],
        };
        if (url) {
          payload.documentTemplateUrl = url;
        }
        const ref = db.collection("contractTemplates");
        if (this.isEditing && this.currentId) {
          await ref.doc(this.currentId).update(payload);
        } else {
          // Beim Anlegen muss immer ein PDF vorhanden sein
          await ref.add(payload);
        }
        this.closeModal();
      } catch (e) {
        console.error("Fehler beim Speichern der Vorlage:", e);
        MessageBox.alert("Fehler beim Speichern der Vorlage.", "Fehler", {
          confirmButtonText: "OK",
          type: "error",
        });
        this.saving = false;
      }
    },
    removeTemplate(row) {
      MessageBox.confirm(
        "Soll die Vorlage '" + (row.title || "(ohne Titel)") + "' wirklich gelöscht werden?",
        "Warnung",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
          callback: (action) => {
            if (action === "confirm") {
              db.collection("contractTemplates")
                .doc(row.id)
                .delete()
                .catch((error) => {
                  console.error("Fehler beim Löschen der Vorlage: ", error);
                });
            }
          },
        }
      );
    },
  },
};
</script>

<style>
.el-table .cell {
  word-break: break-word !important;
}
</style>
